import type {AssetVec3} from '../proceduralAssets.js';
import type {FrontierBuilder} from './frontierExtras.js';
/** Adult counter-idle: elbow ~.17 m forward, wrist ~.36 m forward.
 * The structure leaves .36 m for an upright body. A .19 m working overhang
 * meets the elbow; the forearm and hand rest farther onto the tabletop. */
export const COUNTER_ELBOW_OVERHANG=.19;
export function counterStand(center:AssetVec3,size:AssetVec3,side:-1|1,floorY=.3):AssetVec3 {
  return [center[0],floorY,center[2]+side*(size[2]/2+.36)];
}
/** Only the thin overhang projects into the arm-contact area. Its supporting
 * counter retains collision; feet and torso keep their original clearance. */
export function counterTop(b:FrontierBuilder,center:AssetVec3,size:AssetVec3,material:number,side:-1|1):void {
  b.box(size,center,material,true);
  b.box([size[0],size[1],COUNTER_ELBOW_OVERHANG],
    [center[0],center[1],center[2]+side*(size[2]/2+COUNTER_ELBOW_OVERHANG/2)],material);
}
